import { render } from "./StickyHScroll.vue?vue&type=template&id=52be83cb"
import script from "./StickyHScroll.vue?vue&type=script&lang=js"
export * from "./StickyHScroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__